/**
 * main-product-related: recommendations fetch, recently viewed (localStorage), tabs.
 */
(function () {
  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function readConfig(sectionRoot) {
    const id = sectionRoot.id.replace('MainProductRelated-', '');
    const el = document.getElementById(`MainProductRelated-json-${id}`);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch {
      return null;
    }
  }

  function toCents(value) {
    if (value == null || value === '') return null;
    const n = Number(value);
    if (!Number.isFinite(n)) return null;
    if (n > 0 && n < 100 && String(value).indexOf('.') !== -1) {
      return Math.round(n * 100);
    }
    return Math.round(n);
  }

  function formatMoney(cents, cfg) {
    if (cents == null) return '';
    const amount = (Number(cents) / 100).toFixed(2);
    let fmt = cfg.moneyFormat || '{{amount}}';
    fmt = fmt.replace(/\{\{\s*amount\s*\}\}/gi, amount);
    fmt = fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/gi, String(Math.round(Number(cents) / 100)));
    return fmt;
  }

  function buildPriceHtml(priceCents, compareCents, cfg) {
    const regular = formatMoney(priceCents, cfg);
    const onSale = compareCents != null && Number(compareCents) > Number(priceCents);
    const regLabel = escapeHtml(cfg.regularPriceLabel || '');
    const saleLabel = escapeHtml(cfg.salePriceLabel || '');
    if (!onSale) {
      return `
        <div class="price">
          <div class="price__container">
            <div class="price__regular">
              <span class="visually-hidden visually-hidden--inline">${regLabel}</span>
              <span class="price-item price-item--regular">${regular}</span>
            </div>
          </div>
        </div>`;
    }
    const sale = formatMoney(priceCents, cfg);
    const compare = formatMoney(compareCents, cfg);
    return `
      <div class="price price--on-sale">
        <div class="price__container">
          <div class="price__sale">
            <span class="visually-hidden visually-hidden--inline">${regLabel}</span>
            <span>
              <s class="price-item price-item--regular">${compare}</s>
            </span>
            <span class="visually-hidden visually-hidden--inline">${saleLabel}</span>
            <span class="price-item price-item--sale price-item--last">${sale}</span>
          </div>
        </div>
      </div>`;
  }

  function wishlistButton(handle, cfg) {
    if (!cfg.enableWishlist) return '';
    const label = escapeHtml(cfg.wishlistLabel || '');
    const safeHandle = escapeHtml(handle);
    return `
      <button
        type="button"
        class="card__wishlist"
        data-card-wishlist-handle="${safeHandle}"
        aria-label="${label}"
        aria-pressed="false"
      >
        <span class="card__wishlist__icon" aria-hidden="true">
          <svg class="card__wishlist__outline" xmlns="http://www.w3.org/2000/svg" width="24" height="22" viewBox="0 0 24 24" fill="none" focusable="false">
            <path vector-effect="non-scaling-stroke" d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" stroke="currentColor" stroke-width="1.15" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="card__wishlist__filled">
            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-heart" viewBox="0 0 20 20" width="20" height="20" focusable="false" aria-hidden="true">
              <path fill="currentColor" fill-rule="evenodd" d="M10 5.24 8.515 3.773a4.433 4.433 0 0 0-6.21 0 4.293 4.293 0 0 0 0 6.128L10 17.495l7.695-7.593a4.293 4.293 0 0 0 0-6.128 4.433 4.433 0 0 0-6.21 0zm.765-2.177c2.113-2.084 5.538-2.084 7.65 0a5.29 5.29 0 0 1 0 7.55l-7.695 7.593a1.03 1.03 0 0 1-1.44 0l-7.696-7.594a5.29 5.29 0 0 1 0-7.549C3.697.98 7.122.98 9.234 3.063l.766.755z"/>
            </svg>
          </span>
        </span>
      </button>`;
  }

  function buildRecentCard(product, cfg) {
    const handle = product.handle;
    const url = escapeHtml(product.url || `/products/${handle}`);
    const title = product.title || '';
    const titleSafe = escapeHtml(title);
    const imgRaw = product.featured_image || (product.images && product.images[0]);
    const img =
      typeof imgRaw === 'string'
        ? escapeHtml(imgRaw)
        : imgRaw && typeof imgRaw === 'object' && imgRaw.src
          ? escapeHtml(imgRaw.src)
          : '';
    const priceCents = toCents(product.price_min ?? product.price);
    const compareCents = toCents(product.compare_at_price_min ?? product.compare_at_price ?? product.compare_at_price_max);
    const priceHtml = buildPriceHtml(priceCents, compareCents, cfg);
    const wl = wishlistButton(handle, cfg);

    return `
      <li class="main-product-related__cell">
        <div class="card-wrapper product-card-wrapper underline-links-hover">
          <div class="card card--standard card--media card--extend-height card--full-product-link">
            <a class="card__product-link-full" href="${url}" aria-hidden="true" tabindex="-1">
              <span class="visually-hidden">${titleSafe}</span>
            </a>
            <div class="card__inner ratio" style="--ratio-percent: 100%;">
              <div class="card__media">
                <div class="media media--transparent">
                  ${img ? `<img src="${img}" alt="${titleSafe}" loading="lazy" width="533" height="533">` : ''}
                </div>
                ${wl}
              </div>
            </div>
            <div class="card__content">
              <div class="card__information">
                <h3 class="card__heading h5">
                  <a href="${url}" class="full-unstyled-link">${titleSafe}</a>
                </h3>
                ${priceHtml}
              </div>
            </div>
          </div>
        </div>
      </li>`;
  }

  function recordCurrentView(cfg) {
    const key = cfg.recentStorageKey;
    const handle = cfg.handle;
    const max = 16;
    try {
      const raw = localStorage.getItem(key);
      let list = [];
      if (raw) {
        const p = JSON.parse(raw);
        list = Array.isArray(p) ? p : [];
      }
      list = [handle, ...list.filter((h) => h !== handle)];
      list = list.slice(0, max);
      localStorage.setItem(key, JSON.stringify(list));
    } catch {
      /* ignore */
    }
  }

  function getRecentHandles(cfg) {
    const key = cfg.recentStorageKey;
    try {
      const raw = localStorage.getItem(key);
      if (!raw) return [];
      const p = JSON.parse(raw);
      if (!Array.isArray(p)) return [];
      const cur = cfg.handle;
      const seen = new Set();
      const out = [];
      for (const h of p) {
        if (!h || h === cur || seen.has(h)) continue;
        seen.add(h);
        out.push(h);
        if (out.length >= cfg.limit) break;
      }
      return out;
    } catch {
      return [];
    }
  }

  function loadRecommendationsHtml(cfg) {
    const url = `${cfg.recommendationsUrl}&section_id=${encodeURIComponent(cfg.sectionId)}&product_id=${encodeURIComponent(cfg.productId)}`;
    return fetch(url)
      .then((r) => (r.ok ? r.text() : ''))
      .then((html) => {
        if (!html) return '';
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const host = doc.querySelector('product-recommendations');
        const ul = host?.querySelector('ul.main-product-related__grid');
        return ul ? ul.innerHTML : '';
      })
      .catch(() => '');
  }

  function fetchProductJson(handle) {
    const base = typeof window.shopUrl === 'string' ? window.shopUrl : '';
    return fetch(`${base}/products/${encodeURIComponent(handle)}.js`)
      .then((r) => (r.ok ? r.json() : null))
      .catch(() => null);
  }

  async function loadRecentlyViewedHtml(cfg) {
    const handles = getRecentHandles(cfg);
    if (!handles.length) return '';
    const products = await Promise.all(handles.map(fetchProductJson));
    const chunks = products.filter(Boolean).map((p) => buildRecentCard(p, cfg));
    return chunks.join('');
  }

  function setTabState(section, which, cfg) {
    const tabs = section.querySelectorAll('[data-mpr-tab]');
    const panels = section.querySelectorAll('[data-mpr-panel]');
    tabs.forEach((tab) => {
      const on = tab.dataset.mprTab === which;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.tabIndex = on ? 0 : -1;
    });
    panels.forEach((panel) => {
      const on = panel.dataset.mprPanel === which;
      panel.classList.toggle('is-active', on);
      panel.toggleAttribute('hidden', !on);
    });
  }

  function wireTabs(section, cfg, hasRec, hasRecent) {
    const tabRec = section.querySelector('[data-mpr-tab="recommendations"]');
    const tabRecent = section.querySelector('[data-mpr-tab="recent"]');
    const sep = section.querySelector('[data-mpr-sep]');

    if (hasRec && hasRecent) {
      if (sep) sep.hidden = false;
      if (tabRecent) tabRecent.hidden = false;
      if (tabRec) tabRec.hidden = false;
    } else if (hasRec && !hasRecent) {
      if (sep) sep.hidden = true;
      if (tabRecent) tabRecent.hidden = true;
      if (tabRec) tabRec.hidden = false;
    } else if (!hasRec && hasRecent) {
      if (sep) sep.hidden = true;
      if (tabRec) tabRec.hidden = true;
      if (tabRecent) tabRecent.hidden = false;
    }

    const defaultTab = hasRec ? 'recommendations' : 'recent';
    setTabState(section, defaultTab, cfg);

    section.querySelectorAll('[data-mpr-tab]').forEach((btn) => {
      if (btn.hidden) return;
      btn.addEventListener('click', () => {
        const w = btn.dataset.mprTab;
        if (w === 'recommendations' && !hasRec) return;
        if (w === 'recent' && !hasRecent) return;
        setTabState(section, w, cfg);
      });
    });
  }

  async function initSection(section) {
    const cfg = readConfig(section);
    if (!cfg) return;

    recordCurrentView(cfg);

    const recGrid = section.querySelector('[data-main-product-related-rec-grid]');
    const recentGrid = section.querySelector('[data-main-product-related-recent-grid]');
    if (!recGrid || !recentGrid) return;

    const [recInner, recentInner] = await Promise.all([loadRecommendationsHtml(cfg), loadRecentlyViewedHtml(cfg)]);

    if (recInner) recGrid.innerHTML = recInner;
    if (recentInner) recentGrid.innerHTML = recentInner;

    const hasRec = recGrid.children.length > 0;
    const hasRecent = recentGrid.children.length > 0;

    if (!hasRec && !hasRecent) {
      if (cfg.designMode) {
        section.hidden = false;
        return;
      }
      const sid = section.id.replace('MainProductRelated-', '');
      const shopRoot = section.closest('.shopify-section');
      if (shopRoot) {
        shopRoot.remove();
      } else {
        document.getElementById(`MainProductRelated-json-${sid}`)?.remove();
        section.remove();
      }
      return;
    }

    section.hidden = false;
    wireTabs(section, cfg, hasRec, hasRecent);

    document.dispatchEvent(new CustomEvent('main-product-related:loaded', { bubbles: true, detail: { section } }));
  }

  function init() {
    document.querySelectorAll('[data-main-product-related]').forEach((el) => {
      initSection(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target?.querySelector?.('[data-main-product-related]');
    if (root) initSection(root);
  });
})();
